export default "__VITE_PUBLIC_ASSET__147baaaa__"